"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
require("./index.scss");
const OverclaimConfirmationPopup = (props) => {
    const { onClickConfirm, confirmButtonText, onClickCancel } = props;
    return (react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Submitting your current share percentage will put total shares for this work over 100%, which moves it\n' +
            'into overclaim conflict.', confirmButtonText: confirmButtonText, cancelButtonText: 'Back', onCancel: onClickCancel, onConfirm: onClickConfirm },
        react_1.default.createElement("p", null,
            "Full information about resolving overclaims can be found",
            react_1.default.createElement("a", { href: 'https://help.themlc.com/en/support/what-is-an-overclaim-and-how-do-i-resolve-one-using-the-overclaims-tool' },
                ' ',
                "here.",
                ' '),
            "Click Back to edit your share percentage or Continue to continue submitting with your current share percentage and moving the work into overclaim conflict.")));
};
exports.default = OverclaimConfirmationPopup;
